import { render, staticRenderFns } from "./func-query.vue?vue&type=template&id=72ee0f0d&scoped=true"
import script from "./func-query.vue?vue&type=script&lang=js"
export * from "./func-query.vue?vue&type=script&lang=js"
import style0 from "./func-query.vue?vue&type=style&index=0&id=72ee0f0d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ee0f0d",
  null
  
)

export default component.exports